let moment = require("jalali-moment");

export default {
  data() {
    return {
      formData: new FormData(),
      errorImage: require("@/assets/images/notFound.png"),
    };
  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "0";
      }
    },
    decodePersianName(x) {
      let decodedPersianString = x
        .replace(/[\u200B-\u200C\uFEFF]/g, " ")
        .replace(/  +/g, " ")
        .replace("/", "-")
        .split(" ")
        .join("-");
      return decodedPersianString;
    },
    calcDate(val) {
      let toCurrentLocale = moment.utc(val).local().format();
      return val
        ? moment(toCurrentLocale).locale("fa").format("YYYY/MM/DD HH:mm:ss")
        : "";
    },
    setFormData(element, index, append) {
      if (Array.isArray(element)) {
        element.forEach((element, index) => {
          this.setFormData(element, index, append + `[${index}]`);
        });
      } else if (
        typeof element == "object" &&
        !!element &&
        element instanceof File === false
      ) {
        for (const [key, value] of Object.entries(element)) {
          this.setFormData(value, key, append + `[${key}]`);
        }
      } else if (!!element || element === 0) {
        this.formData.append(append, element);
      }
    },
    // nodes.forEach((element, index) => {
    //   setFormData(element, index, `nodes[${index}]`);
    // });
    //  Object.keys(this.course).map((item, index) => {
    //   this.setFormData(this.course[item], index, item);
    // });
    toGorgian(val) {
      let gorgian = val
        ? moment
            .from(val, "fa", "YYYY/MM/DD HH:mm:ss")
            .format("YYYY-MM-DD HH:mm:ss")
        : "";
      return gorgian;
    },
    getDifference(date2) {
      let currentDate = moment();
      let myDate = moment.utc(date2 * 1000).local();
      let res = "";
      let diffTime = myDate.diff(currentDate, "seconds");
      let day = parseInt(diffTime / (24 * 3600));
      day > 0 ? (res += day + " روز ") : "";
      diffTime = diffTime % (24 * 3600);
      let hour = parseInt(diffTime / 3600);
      hour > 0 ? (res += hour + " ساعت ") : "";
      diffTime %= 3600;
      let minutes = parseInt(diffTime / 60);
      minutes > 0 ? (res += minutes + " دقیقه ") : "";
      diffTime %= 60;
      let seconds = parseInt(diffTime);
      seconds > 0 ? (res += seconds + " ثانیه ") : "";
      return { res, time: { day, hour, minutes, seconds } };
    },
    p2e: (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)),
    setAltImg(event) {
      event.target.src = this.errorImage;
      event.target.alt = "";
    },
  },
};
